export enum actionTypes {
  MODALIDADES_FETCH = 'MODALIDADES_FETCH',
  MODALIDADES_SUCCESS = 'MODALIDADES_SUCCESS',
  MODALIDADES_ERROR = 'MODALIDADES_ERROR',
  MODALIDADES_RESET = 'MODALIDADES_RESET',
}

export enum ModalidadesStatus {
  Idle,
  Loading,
  Error,
  Success,
}

export interface Modalidad {
  id: number
  nombre: string
}

export interface ModalidadesState {
  status: ModalidadesStatus
  modalidades: Array<Modalidad>
}

export interface ModalidadesFetch {
  type: typeof actionTypes.MODALIDADES_FETCH
}

export interface ModalidadesSuccess {
  type: typeof actionTypes.MODALIDADES_SUCCESS
  payload: { modalidades }
}

export interface ModalidadesError {
  type: typeof actionTypes.MODALIDADES_ERROR
  payload: null
}

export interface ModalidadesReset {
  type: typeof actionTypes.MODALIDADES_RESET
  payload: null
}

export type ModalidadesActions = ModalidadesFetch | ModalidadesSuccess | ModalidadesError | ModalidadesReset

export const initialState: ModalidadesState = {
  status: ModalidadesStatus.Idle,
  modalidades: [],
}
